/**
 * UI state for the Company Rankings filter: restrict results to companies that
 * are themselves ranked in the Fortune 500 and/or Forbes Global 2000 (not their
 * global HQ). Both checked means a company must be in both lists.
 */
export type RankingsSlice = {
  fortune500: boolean;
  forbes2000: boolean;
};

export const defaultRankingsSlice: RankingsSlice = {
  fortune500: false,
  forbes2000: false,
};
